<template>
  <div v-show="loading" class="content-wrapper">
    <div class="container">
      <article>

        <div class="loading-body">
          <img src="lib/images/loadingicon.svg" alt="" class="loadingicon" width="50" height="50">
        </div>

      </article>
    </div>

  </div>
</template>

<script>

export default {
  props: [
    'loading'
  ]
}
</script>
